import { Link } from "react-router-dom";
import SEO from "../components/SEO";

export default function Privacy() {
  return (
    <div className="min-h-screen bg-[#050510] text-white" data-testid="privacy-page">
      <SEO title="Privacy Policy" description="How BRep collects, uses and stores your data." path="/privacy" />
      <div className="max-w-3xl mx-auto px-6 md:px-12 py-24">
        <Link to="/" className="text-[11px] tracking-[0.3em] uppercase text-white/60 hover:text-[#2A5BFF] transition-colors" data-testid="privacy-back">← Back</Link>
        <h1 className="font-anton uppercase text-5xl md:text-6xl mt-8">Privacy Policy</h1>
        <p className="mt-6 text-white/60 leading-relaxed">
          BRep ("we", "us") respects your privacy. This policy explains what data we collect and how we use it.
        </p>
        <h2 className="font-anton uppercase text-2xl mt-10">What we collect</h2>
        <p className="mt-3 text-white/60">Your account details (name, email), the services you book, the content you upload (video, notes, messages) and standard usage logs.</p>
        <h2 className="font-anton uppercase text-2xl mt-10">How we use it</h2>
        <p className="mt-3 text-white/60">
          To deliver the service you booked, connect you with your coach, provide customer support, and send transactional updates. We never sell your data.
        </p>
        <h2 className="font-anton uppercase text-2xl mt-10">Storage</h2>
        <p className="mt-3 text-white/60">Your details are stored securely. You can request deletion any time by contacting us.</p>
        <h2 className="font-anton uppercase text-2xl mt-10">Contact</h2>
        <p className="mt-3 text-white/60">hello@thebrep.app</p>
      </div>
    </div>
  );
}
